import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

// ---- Schemes ----
export const createStandaloneScheme = async (data) => {
  const res = await axiosInstance.post("/standalone-marks/schemes/create", data);
  return res.data;
};

export const getAllStandaloneSchemes = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/standalone-marks/schemes/all${qs(filters)}`
  );
  return res.data;
};

export const getStandaloneSchemeById = async (id) => {
  const res = await axiosInstance.get(`/standalone-marks/schemes/${id}`);
  return res.data;
};

export const updateStandaloneScheme = async (id, data) => {
  const res = await axiosInstance.put(
    `/standalone-marks/schemes/update/${id}`,
    data
  );
  return res.data;
};

export const deleteStandaloneScheme = async (id) => {
  const res = await axiosInstance.delete(
    `/standalone-marks/schemes/delete/${id}`
  );
  return res.data;
};

// ---- Teachers ----
export const getTeachersForStandalone = async (filters = {}) => {
  const res = await axiosInstance.get(`/standalone-marks/teachers${qs(filters)}`);
  return res.data;
};

// ---- Assign ----
export const createStandaloneAssignment = async (data) => {
  const res = await axiosInstance.post("/standalone-marks/assign", data);
  return res.data;
};

export const getAllStandaloneAssignments = async (filters = {}) => {
  const res = await axiosInstance.get(
    `/standalone-marks/assignments/all${qs(filters)}`
  );
  return res.data;
};

export const updateStandaloneAssignmentStatus = async (id, data) => {
  const res = await axiosInstance.put(
    `/standalone-marks/assignments/status/${id}`,
    data
  );
  return res.data;
};

// ---- Entry ----
export const getStandaloneEntry = async (assignmentId) => {
  const res = await axiosInstance.get(
    `/standalone-marks/entry/${assignmentId}`
  );
  return res.data;
};

export const saveStandaloneEntry = async (data) => {
  const res = await axiosInstance.post("/standalone-marks/entry/save", data);
  return res.data;
};

export const submitStandaloneEntry = async (assignmentId) => {
  const res = await axiosInstance.post(
    `/standalone-marks/entry/submit/${assignmentId}`
  );
  return res.data;
};

export const getStandaloneEntries = async (filters = {}) => {
  const res = await axiosInstance.get(`/standalone-marks/entries${qs(filters)}`);
  return res.data;
};
